// When user logins or logs out

export default function karteLogin(status: boolean) {
  try {
    (window as any).tracker.track("login", { status });
  } catch (e) {
    console.log("karte.login: ", e);
    if ("tracker" in window) {
      (window as any).tracker.track("_error", {
        message: e.message
      });
    }
  }
}
